export const NAME_ROUTES = {
    HOME: { path: '/', name: 'home' },
    LOGIN: { path: '/login', name: 'login' },
    DELETE_ACCOUNT: { path: '/delete-account', name: 'deleteAccount' },
    ITEM_DETAIL: { path: '/item/:id', name: 'itemDetail' },
    ITEM_WITH_SINISTERS: { path: '/claims/', name: 'itemWithSinisters' },
    CLAIM_DETAIL: { path: '/claim/detail/:id', name: 'claimDetail' },
};
